import { Component,HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service'; 

@Component({
  selector: 'app-payment-history',
  templateUrl: './payment-history.component.html',
  styleUrls: ['./payment-history.component.scss']
})
export class PaymentHistoryComponent implements OnInit {
  paymentHistory: any[] = []; // Store payment history data
  isSmallScreen:boolean =false;
  showOrderSkeletonLoader: boolean = true;
  displayedColumns: string[] = ['deliveryDate', 'invoiceNumber', 'salesOrderNumber','orderTotal', 'paymentMode', 'authCode', 'amountPaid'];

  constructor(private apiService: ApiService,private router:Router) { }

  ngOnInit(): void {
    this.checkScreenWidth();
    this.apiService.getPaymentHistory().subscribe(result => {
      if (result["response"]) {
        this.paymentHistory = result["response"]; // Assign API response to component property
        this.showOrderSkeletonLoader = false;
      }
    }, error => {
      this.showOrderSkeletonLoader = false;
      console.error('Error fetching payment history:', error);
    });
  }

  viewSaleOrder(uuid) {
    this.router.navigate(['account/sale-order',uuid]);
  }
  @HostListener('window:resize', [])
  checkScreenWidth(): void {
    this.isSmallScreen = window.innerWidth < 560;
  }

}
